module.exports = __webpack_public_path__ + "media/19.ace82a19.wav";